
import React from "react";

// COMPONENTS
import Search from "./Search";
// CSS STYLES
import styles from "../../styles/Components/Shared/ListPageHeader.module.css";


const ListPageHeader = ({
    title, 
    description,
    unpublishedNote,
    note,
    subComponent,
    AddComponent,
    searchProps,
    addButtonProps,
    exportProps,
    ExportComponent,
    addedClass = ''
}) => {
    return (
            <div className={styles.header_container}>

                {title || exportProps ? 
                    <div className={`${styles.header_title_row} ${addedClass}`}>
                        { title ? (
                            <p className={styles.header_title}>{title}</p>
                        ): (null)}

                    {exportProps ? (
                        <div 
                            className={styles.header_export_btn} 
                            onClick={() => exportProps.onClickExports()}
                        >
                            <p>{exportProps.text}</p>
                        </div>
                    ) : ExportComponent ? (
                        <ExportComponent />
                    ) : (null) }
                    </div>
                    
                : null}

                {/* PAGE DESCRIPTION */}
                {description ? 
                    <p className={styles.header_description}>{description}</p>
                : null}

                {/* UNPUBLISHED NOTE OR REGULAR PAGE NOTE*/}
                {unpublishedNote ? (
                    <p className={styles.header_note}><span>*</span>  {unpublishedNote}</p>
                ) : note ? (
                    <p className={styles.header_note}>{note}</p>
                ) : (null)}

                {/* SUB COMPONENT */}
                {/* This is used for the TOGGLE VIEW buttons above search */}
                {subComponent ?
                    subComponent
                : null}

                {/* ADD BUTTON + SEARCH ROW */}
                {
                    addButtonProps || searchProps || AddComponent ? (
                    <div className={styles.header_search_row}>

                        {/* ADD BUTTON PROPS OR RENDER PARENT ADD BUTTON COMPONENT */}
                        {AddComponent && !addButtonProps ? 
                            <AddComponent isSmall={false}/>
                        : addButtonProps ? (
                            <div className={`${styles.red_add_button} ${addButtonProps.disabled ? 'button_disabled' : ''}`} onClick={addButtonProps.disabled ? null : addButtonProps.onClick} style={addButtonProps.addedStyles ? addButtonProps.addedStyles : {}}>
                                <p>{addButtonProps.text}</p>
                                {addButtonProps.icon}
                            </div>
                        ) : null}
                        
                        {/* SEARCH INPUT COMPONENT */}
                        {searchProps ?
                            <Search 
                                searchProps={searchProps}
                            />
                        : null}
                    </div>
                    ) : (null)
                }

                
            </div>
    );
};

export default ListPageHeader;
